import {NavLink} from "react-router-dom";

const ErrorLayout = () => {
	return (
		<div className="card custom-card mt-5">
			<div className="card-body">
				<div className="d-flex justify-content-between text-dark py-4">
					<span className="fs-6">
						<strong><i className="fa fa-exclamation fs-5 me-2"/></strong>
						Page not viewable as an error occurred while getting required Information.
					</span>
					<NavLink to="/" type="button" className="btn btn-primary">
						Go to Dashboard
					</NavLink>
				</div>
			</div>
		</div>
	)
}

export default ErrorLayout;
